import { MDBBtn, MDBCard, MDBCardBody, MDBCardFooter, MDBCardHeader, MDBSpinner } from "mdb-react-ui-kit"
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { Alert } from "../Alert";
import { CustomModal } from "../CustomModal";
import { LoadingSpinner } from "../LoadingSpinner";

export interface ActionModalProps {
    open: boolean;
    title: string;
    action: () => Promise<void>;
    canSave?: boolean;
    confirmText?: string;
    style?: StyleSheet;
    danger?: boolean;
    children: React.ReactNode;
    onClose: () => void;
}
export const ActionModal = ({
    open,
    title,
    canSave,
    action,
    confirmText,
    style,
    danger,
    children,
    onClose
}: ActionModalProps) => {
    const { t } = useTranslation();
    const [error, setError] = useState<string|null>(null);
    const [loading, setLoading] = useState(false);

    const submit = useCallback(async () => {
        setError(null);
        setLoading(true);
        try {
            await action();
            onClose();
        }catch(err: any){
            setError(err.message);
            setLoading(false);
        }
    }, [action]);

    useEffect(() => {
        setError(null);
        setLoading(false);
    }, [open]);
    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={title}
            footer={<>
                <MDBBtn color="secondary" onClick={onClose} disabled={loading}>{t('cancel')}</MDBBtn>
                <MDBBtn disabled={!canSave || loading} onClick={submit} color={danger?"warning":undefined} style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center', display: 'flex'}}>
                    {loading && <LoadingSpinner size="sm" className="p-0 me-1"/>}
                    {<span>{confirmText ?? t('save')}</span>}
                </MDBBtn>
            </>}
        >
            <div className="d-flex flex-column px-3">
                {children}
                {error && <Alert type="danger" message={error}/>}
            </div>
        </CustomModal>
    )
}